import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mapLocationAddPageComponent from './mapLocationAddPage.component';

let mapLocationAddPageModule = angular.module('mapLocationAddPage', [
  uiRouter
])

.component('mapLocationAddPage', mapLocationAddPageComponent)

.name;

export default mapLocationAddPageModule;
